import { render } from "./Grupos.vue?vue&type=template&id=e1f44090&scoped=true"
import script from "./Grupos.vue?vue&type=script&lang=js"
export * from "./Grupos.vue?vue&type=script&lang=js"

import "./Grupos.vue?vue&type=style&index=0&id=e1f44090&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e1f44090"]])

export default __exports__